import React from 'react';
import { Spinner } from '@danfoss/webex-ui';
import { useStyles } from './Styles';

type State = { setSpinnerVisibility: any }
type Props = {
  children: any
}
const SpinnerContext = React.createContext<State | undefined>(undefined);
export const useSpinner = () => React.useContext(SpinnerContext);

export const SpinnerProvider: React.FC<Props> = ({ children }) => {
  const classes = useStyles();

  const [show, setSpinnerVisible] = React.useState(false);

  return (
    <SpinnerContext.Provider value={{ setSpinnerVisibility: (visible: boolean) => setSpinnerVisible(visible) }}>
      {show && (
        <div className={classes.overlay}>
          <Spinner visible />
        </div>
      )}
      {children}
    </SpinnerContext.Provider>
  )

}
